export default __webpack_public_path__ + "static/media/mc-logo_30x24.7890df9b.svg";